class BtnUpload extends HTMLElement {
  constructor() {
    super();
    console.log("%cUPLOADING", "background:green;color:white;padding:10px");

    this.uploadKitEv = new Event('adduploadkit');
    
    this.inputs = {};

    this.onWaitUploadKit();

    this.addEventListener('adduploadkit', () => {
      let nameInput = false;
      
      const product = JSON.parse(document.querySelector('#step-block-product').textContent);
      const nameTag = [
        'upload with custom text',
        'upload and text',
        'upload with pets name',
        'upload two pets with name',
        'upload three pets with name',
        'upload four pets with name',
        'upload five pets with name',
        'upload six pets with name',
        'upload with name and location',
      ];

      for (const tag of product.tags) {
        nameInput = nameTag.includes(tag);
        if(nameInput) break;
      }

      if(nameInput) {
        this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
          let proName = btn.dataset['uploaderName'];
    
          const label = document.createElement('label');
          let num = arg;
          if(document.querySelectorAll('.uploadkit-button').length > 1) {
            num = arg + 1;
          } else {
            num = '';
          }
  
          const labelName = document.createTextNode(`Pet Name ${num}`);
          label.appendChild(labelName);
    
          const inputName = document.createElement('input');
          inputName.setAttribute('type', 'text');
          inputName.setAttribute('class', 'pet-name');
          inputName.setAttribute('name', `properties[_${proName}_petName]`);
          inputName.setAttribute('placeholder', 'e.g Tom, Bruno, etc.');
          inputName.setAttribute('value', '');
    
          const pet_name = document.createElement('div');
          pet_name.classList.add('pet_name');
    
          pet_name.appendChild(label);
          pet_name.appendChild(inputName);
    
          btn.after(pet_name);
          let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
          this.inputs.properties = {...this.inputs.properties, ...property};
        });
      }
      console.log(this.inputs);
    });
  }

  onWaitUploadKit() {
    let uploadkit = setInterval(() => {
      if(this.querySelector('.uploadkit-button')) {
        this.dispatchEvent(this.uploadKitEv);
        clearInterval(uploadkit);
      }
    }, 500);
  }

}
customElements.define('upload-btn-wrapper', BtnUpload);

class BtnBefore extends HTMLElement {
  constructor() {
    super();

    this.beforeEv = new Event('before', {bubbles: true});

    this.addEventListener('click', this.onBeforeClick.bind(this));
  }

  onBeforeClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.beforeEv);
  }
}
customElements.define('before-btn', BtnBefore);

class BtnNext extends HTMLElement {
  constructor() {
    super();

    this.nextEv = new Event('next', {bubbles: true});

    this.addEventListener('click', this.onNextClick.bind(this));
  }

  onNextClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.nextEv);
  }
}
customElements.define('next-btn', BtnNext);

class OptionItem extends HTMLElement {
  constructor() {
    super();

    this.selectEv = new Event('selectopt', {bubbles: true});

    this.addEventListener('click', this.onSelectOption.bind(this));
  }

  connectedCallback() {
    this.v_option = this.dataset['v_option'];
    this.step = this.dataset['option'];
    let parentEl = document.querySelector(`[data-step="${this.step}"]`) || this.parentElement;
    try {
      const siblings = Array.from(parentEl.querySelectorAll('option-item'))
        .filter(sibling => sibling !== this);
      this.siblings = siblings.length ? siblings : null;
    } catch (err) {
      console.error(`Error selecting siblings: ${err.message}`);
      this.siblings = null;
    }
  }

  onSelectOption() {
    if (!this.siblings) return;
    this.siblings.forEach(sibling => sibling.classList.toggle('selected', false));

    this.classList.toggle('selected', true);
    setTimeout(() => {
      this.dispatchEvent(this.selectEv);
    }, 300);
  }
}
customElements.define('option-item', OptionItem);

class ExtraAdd extends HTMLElement {
  constructor() {
    super();
    this.v_id = this.dataset['v_id'];

    this.addExtraEv = new Event('addextra', {bubbles: true});
    this.removeExtraEv = new Event('removeextra', {bubbles: true});

    this.addEventListener('click', this.updateState.bind(this));
  }

  updateState(ev) {
    ev.preventDefault();

    if(this.classList.contains('added')) {
      this.classList.remove('added');
      this.dispatchEvent(this.removeExtraEv);
    } else {
      this.classList.add('added');
      this.dispatchEvent(this.addExtraEv);
    }
  }
}
customElements.define('extra-add', ExtraAdd); 

class StepBlock extends HTMLElement {
  constructor() {
    super();
    
    this.steps = [];

    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
    this.product = JSON.parse(document.querySelector('#step-block-product').textContent);
    this.product.options.forEach(option => {
      this.steps.push(option.toLowerCase());
    });
    this.steps.push('logo');
    let m_product_containers = document.querySelectorAll('.step-block-product_metafields');
    this.m_products = [];
    for (const element of m_product_containers) {
      let m_product = JSON.parse(element.textContent);
      this.m_products.push(m_product);
    }
    
    localStorage.setItem('custom_product', this.product.handle);
    let extra_title = document.querySelector('#step-extras .process-name').textContent;
    localStorage.setItem('extra_title', extra_title);

    localStorage.setItem('m_products', JSON.stringify(this.m_products));

    for (const variant of this.product.variants) {
      if(variant.available) {
        this.cur_variant = variant;
        this.cur_options = variant.options.join();
        let optionNames = this.product.options;
        this.cur_variant.options.forEach( (option, arg) => {
          document.querySelectorAll(`[data-step="${optionNames[arg]}"] option-item`).forEach( item => {
            let v_option = item.dataset['v_option'];
            v_option == option ? item.classList.toggle('selected', true) : null;
          })
          if (arg == 2) {
            document.querySelectorAll(`[data-step="Logo"] option-item`).forEach( item => {
              let v_option = item.dataset['v_option'];
              v_option == option.split(" / ")[1] ? item.classList.toggle('selected', true) : null;
            })
          }
        });
        this.dataset['v_id'] = this.cur_variant.id;
        break;
      }
    }

    this.steps.push('upload', 'extra');

    this.items = [
      {
        id: this.cur_variant.id,
        quantity: 1,
        price: this.cur_variant.price,
        properties: {
          '__step-product': true
        }
      }
    ];
    
    this.addCartEv = new Event('customaddcart', {bubbles: true});

    this.beforeBtn = this.querySelector('before-btn');
    this.nextBtn = this.querySelector('next-btn');
    this.addCartBtn = this.querySelector('.atc-btn');
    this.uploadWrap = this.querySelector('upload-btn-wrapper');
    
    this.setStep(0, false);

    this.addActions();

    this.updateSubTotal();

  }

  addActions() {
    this.addEventListener('selectopt', this.onSelectOption.bind(this));
    this.addEventListener('before', this.onBeforeStep.bind(this));
    this.addEventListener('next', this.onNextStep.bind(this));
    this.addEventListener('addextra', this.onAddExtra.bind(this));
    this.addEventListener('removeextra', this.onRemoveExtra.bind(this));
    this.addEventListener('customaddcart', this.onAddCart);
    this.addCartBtn.addEventListener('click',() => {
      this.dispatchEvent(this.addCartEv);
    });
  }

  onSelectOption(ev) {
    let cur_index = this.dataset.index;
    let value = ev.target.v_option;

    this.updateVariant(cur_index, value);
  }
  
  onBeforeStep(ev) {
    // debugger;
    let index = ev.target.dataset['index'];
    console.log(index);
    index > 0 ? index--: index;
    console.log(index);

    this.setStep(index);
  }
  
  onNextStep(ev) {
    let index = ev.target.dataset['index'];
    let current = this.steps[index];

    let limit = this.steps.length;
    limit--;

    index < limit ? index++: index;
    if(current == 'upload') {
      var validated = true;
      var imageAttrContainers = $(this).find('.uploadkit-attribute-container');

      if (window.UploadKit && imageAttrContainers.length > 0 ) {
          for(var i=0; i<imageAttrContainers.length; i++) {
              if(imageAttrContainers[i].innerHTML === '') {
                  validated = false;
              }
          }

      }
      
      if(this.items[0]['properties'] == undefined) {
        Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });
      }

      this.uploadWrap.querySelectorAll('input').forEach(input => {
        let key = input.name.replace('properties[', '').replace(']','');
        this.items[0]['properties'][key] = input.value;
      });

      console.log( this.items);
      if (validated) {
        this.setStep(index);
      } else {
          $('.mb_container').fadeIn();
          // alert('Please upload image first');
      }
    }
    else  this.setStep(index);

  }

  setStep(index, scroll=true) {

    this.dataset['index'] = index;
    this.dataset['current'] = this.steps[index];

    let before, next, limit;

    limit = this.steps.length;
    
    index > 0 ? before = this.steps[index - 1] : before = this.steps[0];
    index < --limit ? next = this.steps[index + 1] : next = this.steps[-1];

    this.beforeBtn.dataset['index'] = index;
    this.beforeBtn.dataset['current'] = this.steps[index];
    this.beforeBtn.dataset['before'] = before;
    this.beforeBtn.dataset['next'] = next;

    this.nextBtn.dataset['index'] = index;
    this.nextBtn.dataset['current'] = this.steps[index];
    this.nextBtn.dataset['before'] = before;
    this.nextBtn.dataset['next'] = next;

    this.querySelectorAll('.step-process').forEach( (process, arg) => {
      // debugger;
      if(arg == index) {
        process.classList.remove('active');
        process.classList.add('current');
      } 
      else if(arg < index) {
        process.classList.add('active');
        process.classList.remove('current');
      }
      else {
        process.classList.remove('active');
        process.classList.remove('current');
      }
    });

    if(this.steps[index] != 'upload' && this.steps[index] != 'extra' && this.steps[index] != 'logo') {
      this.updatePremium(index);
    }

    if(scroll) {
      console.log(window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      if(window.innerWidth < 1024 ) {
        window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      }
    }
    if(this.steps[index] == 'extra') {
      window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
    }
  }

  updatePremium(index) {
    const curOption = this.cur_variant.options;
    let step = this.steps[index];
    let symbol = this.cur_symbol;
    step = capitalize(step);

    const subVariants = this.product.variants.filter( variant => {
      let isPassed = true;
      let i = 0;

      do {
        if( i != index) {
          variant.options[i] === curOption[i] ? isPassed = true : isPassed = false;
        }
        if(!isPassed) return isPassed;
        i++;
      } while (i < curOption.length);
      return isPassed
    });

    let premiumPrices = {};
    let curPrice = this.cur_variant.price;

    subVariants.forEach( variant => {
      let delta = variant.price - curPrice;
      Object.assign(premiumPrices, {[variant.options[index]]: delta});
    });

    console.log(this.cur_variant);
    console.log(subVariants);
    console.log(premiumPrices);
    console.log(this.steps[index]);

    const parent = document.querySelector(`[data-step="${step}"]`);
    console.log(parent);
    parent.querySelectorAll('option-item').forEach( item => {
      let value = item.dataset['v_option'];
      let premiumPrice = premiumPrices[value];
      switch(step) {
        case 'Frame':
        case 'Framing Option':
          premiumPrice > 0 ? item.querySelector('.frame-price').innerHTML = `+${symbol}${premiumPrice/100}` : item.querySelector('.frame-price').innerHTML = '';
          break;
        case 'Size':
          premiumPrice > 0 ? item.querySelector('.size-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.size-wrapper').innerHTML = '';
          break;
        case 'Color':
        case 'Tray Color':
          premiumPrice > 0 ? item.querySelector('.bg-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.bg-wrapper').innerHTML = '';
          break;
      }
    });
  }

  onAddExtra(ev) {
    let v_id = ev.target.dataset['v_id'];
    let v_price = ev.target.dataset['v_price'];
    let item = {
      id: v_id,
      quantity: 1,
      price: v_price,
    };

    this.items.push(item);

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  onRemoveExtra(ev) {
    let v_id = ev.target.v_id;
    console.log(v_id);
    this.items.forEach((item, arg) => {
      if(item.id == v_id) this.items.splice(arg, 1);
    });

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  updateVariant(cur_index, value) {
    console.log("---------updateVariant function");
    console.log(cur_index);
    console.log(value);
    let cur_options = this.cur_options.split(',');
    
    if (cur_index == 3) {
      //cur_options[cur_index] = value;
      cur_options[2] = `${cur_options[2].split(' / ')[0]} / ${value}`;
    } else if (cur_index == 2) {
      cur_options[2] = `${value.split(' / ')[0]} / ${cur_options[2].split(' / ')[1]}`;
    } else {
      cur_options[cur_index] = value;
    }
    console.log(cur_options);

    this.product.variants.forEach( variant => {
      for (let i = 0; i < cur_options.length; i++) {
        if(variant.options[i] == cur_options[i]) {
          if(i == cur_options.length - 1) {
            this.cur_variant = variant;
            this.cur_options = cur_options.join();
            break;
          }     
        } else {
          break;
        }
      }
    });

    this.items[0].id = this.cur_variant.id;
    this.items[0].price = this.cur_variant.price;

    Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });

    this.updateSubTotal();

    if(this.cur_variant.featured_media) {

      let v_img = this.cur_variant.featured_media.id;
      let slidedImage = false;
  
      document.querySelectorAll('.mySwiper2 .swiper-slide img').forEach( (img, arg) => {
        if(img.dataset['id'] == v_img && slidedImage != true) {
          slidedImage = true;
          window.mySwiper.slideTo(arg);
        }
      });
    }

    console.log(this.cur_variant);
    console.log(this.items);
    
    if (this.steps[cur_index] != 'logo') {
      this.updatePremium(cur_index);
    }
  }

  onAddCart() { 
    const items = this.items;
    var free_mug_index = -1;
    for (let index = 0; index < items.length; index++) {
      var item = items[index];
      if (item.properties != undefined) {
        if (item?.properties['__free-mug']){
          free_mug_index = index;
        }
      }
    }
    console.log("free mug index", free_mug_index);
    if (free_mug_index > 0){
      items.splice(free_mug_index, 1);
    }
    
    const sections = 'cart-drawer';

    let product_info = JSON.parse(document.querySelector('#step-block-product').textContent);
    let mug_vt_id = document.querySelector("step-block").getAttribute("mug-v_id");
    let main_item = this.items[0];
    let main_prop = main_item["properties"];
    main_prop["__time"] = Date.now();
    let mug_prop = JSON.stringify(main_prop);
    mug_prop = JSON.parse(mug_prop);
    delete mug_prop["__step-product"];
    mug_prop["__free-mug"] = "true";
    let mug = {
      id: mug_vt_id,
      quantity: 1,
      price: 0,
      properties: mug_prop
    };
    
    let true_mug = false;
    for (let i = 0; i < product_info.variants.length; i++) {
      if (product_info.variants[i].id == main_item.id) {
        let main_variant = product_info.variants[i];
        if (main_variant.option2 != "Unframed") {
          true_mug = true;
        }
      }
    }

    if (true_mug && mug_vt_id != "") {
      items.push(mug);
    }

    document.querySelector('.atc-btn').classList.toggle("loading", true);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items,
            sections
        })
    })
    .then(res => res.json())
    .then(res => {
        console.log(res);
        let step_header = document.querySelector('.step-header-wrapper').outerHTML;
        let step_header_style = document.querySelector('#step-header-style').outerHTML;
        localStorage.setItem('step_header', step_header);
        localStorage.setItem('step_header_style', step_header_style);
        document.querySelector('.atc-btn').classList.toggle("loading", true);
        switch(window.cta_target) {
          case 'bundle':
            window.location.href = window.location.origin + '/pages/bundle-and-save';
            break;
          case 'checkout':
            window.location.href = window.location.origin + '/checkout';
            break;
          case 'cart':
            window.location.href = window.location.origin + '/cart';
            break;
          default:
            reBuildCart();
            open_cart_drawer();
            document.querySelector('.atc-btn').classList.toggle("loading", false);
          }
    })
    .catch(err => console.log(err));

  }

  updateSubTotal() {
    let subTotal = 0;
    let symbol = this.cur_symbol;
    let rate = parseFloat(window.Shopify.currency.rate);

    for (const item of this.items) {
      subTotal += parseInt(item.price);
    }

    const freeShippingThresholdCents = window.__themeFreeShippingThresholdCents ?? 10000;
    try {
      this.querySelector('.subtotal .money').innerHTML = `${symbol}${(subTotal / 100 ).toFixed(2)}`;
      if (subTotal < freeShippingThresholdCents) {
        this.querySelector('.step-freeshipping').innerHTML = `<p>You're only <span class="money">${symbol}${((freeShippingThresholdCents - subTotal)/100).toFixed(2)}</span> away from <strong>FREE SHIPPING</strong></p>`;
      } else {
        this.querySelector('.step-freeshipping').innerHTML = "<p>Congrats! You've earned <strong>FREE SHIPPING</strong></p>";
      }
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('step-block', StepBlock);

function capitalize(str) {
  let words = str.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  let capitalizedStr = words.join(" ");
  return capitalizedStr;
}